module.exports = __webpack_public_path__ + "sunsemweb/img/bg2.2dee63be.png";